import {
  Checkbox,
  FormControlLabel,
  Stack,
  styled,
  Typography,
  Theme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../constants/routes';
import { ChangeEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { isReactNative } from '../../../../common/utils/reactNativeHelpers';

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.green.main,
}));

export const TermsOfUsage = ({
  onChange,
  value,
  error,
  name,
}: {
  error?: string | false | undefined;
  value: boolean;
  name: string;
  onChange:
    | ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
}) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ position: 'relative' }}>
      <FormControlLabel
        control={
          <Checkbox
            sx={(theme: Theme) => ({
              '&.Mui-checked': {
                color: theme.palette.green.main,
              },
              '&&:not(.Mui-checked) .MuiSvgIcon-root': {
                fill: theme.palette.common.white,
              },
            })}
            onChange={onChange}
            name={name}
            value={value}
          />
        }
        label={
          <Typography variant="body1" color="common.white">
            <StyledLink target={isReactNative ? '_self': "_blank"} to={`/${ROUTES.TERMS_OF_USAGE}`}>
              {t('userAuth.termsOfUsage')}
            </StyledLink>
          </Typography>
        }
      />
      {error ? (
        <Typography
          sx={{ position: 'absolute', top: '85%', left: '20px' }}
          variant="body2"
          color="error"
        >
          {error}
        </Typography>
      ) : null}
    </Stack>
  );
};
